/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { ISeminar } from "../../../interfaces/ISeminar";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import * as XLSX from "xlsx";

import { normalizer } from "../../../utils/auxiliar/investigators";

export const Seminars: FC = () => {
  let { isAdmin } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { SEMINARS } = paths;
  const [seminars, setSeminars] = useState<ISeminar[]>([]);
  const [displaySeminars, setDisplaySeminars] = useState<ISeminar[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadData = async () => {
    try {
      const response = 
       await getAll(SEMINARS, source)
      
      if (isMountedRef.current) {
        setSeminars(response);
       
        setDisplaySeminars(response);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled"); 
    }
  };

  const searchBar = (value: any) => {
    setDisplaySeminars(
      seminars.filter(({ titleEs }: any) =>
        normalizer(titleEs).toLowerCase().includes(normalizer(value).toLowerCase())
      )
    );
    !value && setDisplaySeminars(seminars);
  };

 const handleExportToExcel = () => {
   if (!seminars) return;

   const dataToExport = seminars.map((seminario: any) => ({
     "Título (ES)": seminario.titleEs,
     "Título (EN)": seminario.titleEn,
     "Título (VA)": seminario.titleVa,
     "Resumen (ES)": seminario.abstractEs,
     "Resumen (EN)": seminario.abstractEn,
     "Resumen (VA)": seminario.abstractVa,
     "CV Ponente": seminario.cvPonente,
     Lugar: seminario.lugar,
     "Fecha y Hora": seminario.fechaHora
       ? new Date(seminario.fechaHora).toLocaleString()
       : "",
     "Nombre Ponente": seminario.nombrePonente,
     "Instituto Ponente": seminario.institutoPonente,
     "Video Seminario": seminario.videoSeminario,
     "Nota de Prensa": seminario.notaDePrensa || "",
     Interno: seminario.interno ? "Sí" : "No",
   }));

   const worksheet = XLSX.utils.json_to_sheet(dataToExport);
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Seminarios");

   XLSX.writeFile(workbook, "seminarios.xlsx");
 };


  return (
    <div className="container-fluid p-4">
      {(isAdmin || !isAdmin) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Seminarios</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.Seminars.create)}
                >
                  + Añadir
                </button>
                <button className="baseBtn ml-2" onClick={handleExportToExcel}>
                  Descargar Excel
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <div className="row">
            <div className="col-12 ">
              <table className="table table-hover">
                <tbody>
                  {displaySeminars?.map(({ id, titleEs }) => (
                    <tr
                      key={id}
                      className="pointer"
                      onClick={() =>
                        history.push(`${ROUTES.Seminars.all}/${id}`)
                      }
                    >
                      <td>{titleEs}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {isLoading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border mt-5" role="status" />
                </div>
              )}

              {!displaySeminars.length && !isLoading && (
                <div className="d-flex justify-content-center mb-3">
                  <h5>-No hay seminarios para mostrar-</h5>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
